import { render } from "./LayoutPDF.vue?vue&type=template&id=11bb0786&ts=true"
import script from "./LayoutPDF.vue?vue&type=script&lang=ts"
export * from "./LayoutPDF.vue?vue&type=script&lang=ts"

import "./LayoutPDF.vue?vue&type=style&index=0&id=11bb0786&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__